<template>
  <div>
    <q-card class="auth-card relative-position">
      <q-card-main>
        <h1 class="text-center auth-card__heading">{{ $t('login_heading') }}</h1>
        <p class="text-center auth-card__description">{{ $t('login_description') }}</p>

        <form id="login-form" @submit.prevent="handleLogin">
          <!-- Username -->
          <q-field :error="errors.has('email')" :error-label="errors.first('email')">
            <q-input
              name="email"
              v-model="email"
              v-validate.disable="'required'"
              type="email"
              :float-label="$t('email')"
              required
              autofocus/>
          </q-field>

          <!-- Password -->
          <q-field :error="errors.has('password')" :error-label="errors.first('password')">
            <q-input
              name="password"
              v-model="password"
              v-validate.disable="'required'"
              ref="password"
              type="password"
              :float-label="$t('password')"
              required/>
          </q-field>

          <div class="auth-card__footer row justify-between">
            <div class="col-md-auto col-xs-12 self-center auth-card__secondary-action">
              <router-link :to="{ name: 'register' }" class="router-link">{{ $t('register') }}</router-link>
            </div>

            <div class="col-md-auto col-xs-12 self-center auth-card__primary-action">
              <q-btn type="submit" color="primary">{{ $t('login') }}</q-btn>
            </div>
          </div>
        </form>
      </q-card-main>

      <q-inner-loading :visible="loading"/>
    </q-card>
    <router-link :to="{ name: 'forgot-password' }" class="auth-page__bottom-link router-link">{{ $t('forgot_password') }}</router-link>
  </div>
</template>

<script>
  import { createErrorFromResponse, getErrorCodeFromResponse } from 'src/utils/error'
  import { mapActions } from 'vuex'

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    data () {
      return {
        email: '',
        password: '',
        loading: false
      }
    },

    methods: {
      ...mapActions(['login', 'saveCredentials']),

      handleLogin () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) {
              return
            }

            this.loading = true

            this.login({ email: this.email, password: this.password })
              .then(() => {
                this.$router.replace('/')
              })
              .catch(error => {
                this.loading = false

                this.showError(error)
              })
          })
      },

      showError (error) {
        if (error.response) {
          if (getErrorCodeFromResponse(error) === '2FA_REQUIRED') {
            this.saveCredentials({
              email: this.email,
              password: this.password
            })

            this.$router.replace({ name: 'two-factor' })
          } else {
            createErrorFromResponse(error)
          }

          if (getErrorCodeFromResponse(error) === 'INVALID_CREDENTIALS') {
            this.resetPassword()
          }
        } else if (error.message) {
          // Todo: this case should probably also translated
          this.$q.notify({ message: error.message, type: 'negative' })
        }
      },

      resetPassword () {
        this.password = null
        this.$refs.password.focus()
      }
    }
  }
</script>
